export const MODULE_CLASS_NAME = 'EwoDefinitionModule';

export enum ViewNames {
    EWO_FORM_VIEW = 'ewo-form-view',
    CRN_KNOWLEDGEBASE_VIEW = 'crn-knowledgebase-view',
    EWO_REPORTING_VIEW = 'ewo-reporting-view'
}

export enum UserRoles {
    SUPER_USER= 'SUPER_USER',
    ULTRA_USER='ULTRA_USER'
}

export const EWO_LABEL:string='EWO';
